import { getLocale } from "../runtime";

const sv_productusp1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Begränsat lager`
};

const productusp1 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_productusp1(inputs)
	return "productUsp1";
};

export { productusp1 as "productUsp1" };